import PropTypes from "prop-types";
import * as React from "react";
import classNames from "classnames";

import { toRoman } from "helpers/formatting";

import styles from "./BattleTeamsList.scss";

const propTypes = {
  userTeam: PropTypes.object,
  enemyTeam: PropTypes.object,
  isShow: PropTypes.bool
};

class BattleTeamsList extends React.Component {

  renderShip(icons, survived) {
    if (!icons) return null;

    let icon = survived ? icons.alive : icons.dead;
    return <img className={styles.shipImage} src={icon} alt="" />;
  }

  renderTeam(players, isEnemy) {
    const teamList = players.map((player, index) => {
      let shipName, shipLevel, shipIcon;
      if (player.ship) {
        shipName = player.ship.name;
        shipLevel = toRoman(player.ship.level);
        shipIcon = this.renderShip(player.ship.icons, player.survived);
      } else {
        shipName = shipLevel = shipIcon = '';
      }
      return <div key={index} className={classNames(styles.player, { [styles.isSurvived]: player.survived })}>
                    <div className={styles.nickname}>{player.nickname}</div>
                    {shipIcon}
                    <div>{shipLevel}</div>
                    <div className={styles.shipName}>{shipName}</div>
                </div>;
    });

    return <div className={classNames(styles.team, { [styles.enemyTeam]: isEnemy })}>
                {teamList}
            </div>;
  }

  render() {
    return <div className={classNames(styles.container, { [styles.isShow]: this.props.isShow })}>
                {this.renderTeam(this.props.userTeam.players)}
                {this.renderTeam(this.props.enemyTeam.players, true)}
            </div>;
  }
}

BattleTeamsList.propTypes = propTypes;

export default BattleTeamsList;